import React, { useEffect, useState, useContext } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';

import { V_PARTIAL_DISCHARGE_STATUS_ITEM } from '../PartialDischarge';
import { TableBaseStyle } from '../PartialDischargeStyle';
import PartialDischargeGridRow from './PartialDischargeGridRow';
import { useTranslation } from 'react-i18next';

type PartialDischargeGridProps = {
    //isDispPLC: boolean;
    partialDischargeTypeList: V_PARTIAL_DISCHARGE_STATUS_ITEM[];
    onChangeRowData: (value: V_PARTIAL_DISCHARGE_STATUS_ITEM) => void;
};


const PartialDischargeGrid = (props: PartialDischargeGridProps) => {

    const tableStyle = TableBaseStyle();
    const { t } = useTranslation();

    /**
    * 行変更通知
    * @returns
    */
    const changePartialDischargeType = (target: V_PARTIAL_DISCHARGE_STATUS_ITEM) => {

        props.onChangeRowData(target)
    };


    return (
        <>
            <TableContainer component={Paper} className={tableStyle.tableContainer}>
                <Table aria-label="alarm summary" stickyHeader className={tableStyle.tableStyle}>
                    <TableHead>
                        <TableRow>
                            <TableCell className={tableStyle.headerCell}>
                                {t('PartialDischargeGrid.No', 'No.')}
                            </TableCell>
                            <TableCell className={tableStyle.headerCell}>
                                {t('PartialDischargeGrid.機器番号_名称', '機器番号・名称')}
                            </TableCell>
                            <TableCell className={tableStyle.headerCell}>
                                {t('PartialDischargeGrid.状態', '状態')}
                            </TableCell>
                            <TableCell className={tableStyle.headerCell}>
                                {t('PartialDischargeGrid.最新収集時刻', '最新収集時刻')}
                            </TableCell>
                            <TableCell className={tableStyle.headerCell}>
                                {t('PartialDischargeGrid.手動収集', '手動収集')}
                            </TableCell>
                            <TableCell className={tableStyle.headerCell}>
                                {t('PartialDischargeGrid.次回収集予定', '次回収集予定')}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.partialDischargeTypeList.map((row, index) => {
                            return (
                                <PartialDischargeGridRow
                                    key={index}
                                    indexNo={index}
                                    partialDischargeType={row}
                                    partialDischargeTypeList={props.partialDischargeTypeList}
                                    onChangeData={changePartialDischargeType}
                                ></PartialDischargeGridRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
export default PartialDischargeGrid;